import { useTranslation } from 'react-i18next'
import { twMerge } from 'src/utils/tw-merge.util'

type TimelineLinkProps = {
  done?: boolean
  displayToday?: boolean
}

const TimelineLink = ({ done, displayToday }: TimelineLinkProps) => {
  const { t } = useTranslation()
  return (
    <div>
      <div className={twMerge('link__body', done && 'link__body--muted')} />
      {displayToday && (
        <div className="link__today">
          <div>{t('components.patient.patient-file.body.timeline.today')}</div>
          <div className="link__arrow" />
        </div>
      )}
    </div>
  )
}

export default TimelineLink
